import { debounce, delay } from 'lodash';
import moment from 'moment';
import { useEffect, useRef } from 'react';
import { Outlet, useParams } from 'react-router-dom';
import { useReactToPrint } from 'react-to-print';
import { IResponseData } from 'services/response';
import { useAppDispatch } from 'store/hooks';
import styled from 'styled-components';
import storage from 'utils/sessionStorage';
import { setPageLoading } from 'widgets/PageLoading';
import { PAYMENT_TYPE, SHOP_DEVICE_TYPE } from '../Cashier/cashier.constants';
import { useSocketContext } from '../Cashier/hooks/useSocket';
import cashierService from '../services';
import cashierApis from '../services/apis';
import { IBillInfoResData } from '../services/types/bill';
import TicketReceipt from './TicketReceipts';
import TicketWrapperContext from './context';

function ReceiptsLayout() {
  const { shop_id = '' } = useParams();
  const dispatch = useAppDispatch();
  const divRef = useRef<HTMLDivElement>(null);
  const divOwnerRef = useRef<HTMLDivElement>(null);

  const socket = useSocketContext();
  const initConnectSocket = debounce(() => socket.connect(), 100);
  useEffect(() => {
    const isCheckInRoute = location.pathname?.includes(`store/${shop_id}/check-in`) || location.pathname.includes('ticket/qr-payment/customer-side');
    storage.device_type.set(isCheckInRoute ? SHOP_DEVICE_TYPE.SIGNATURE : SHOP_DEVICE_TYPE.POS);

    initConnectSocket();
    return () => {
      socket.unsubscribeAll();
    };
  }, []);

  const doPrint = useReactToPrint({
    contentRef: divRef,
  });

  const doPrintDoubleReceipt = useReactToPrint({
    contentRef: divOwnerRef,
    onAfterPrint: () => {
      delay(() => doPrint(), 100);
    },
  });

  const doPrintOwnerReceipt = useReactToPrint({
    contentRef: divOwnerRef,
  });

  const handlePrint = async (billId: string) => {
    setPageLoading(true);
    try {
      const res: IResponseData<IBillInfoResData> = await cashierApis.getBillById(billId);

      if (res.data.data) {
        dispatch(cashierService.actions.saveTicketPrinterDetail(res.data.data));
        setTimeout(() => doPrintOwnerReceipt(), 100);
      }
    } catch (error) { } finally {
      setPageLoading(false);
    }
  };

  const handlePrintWithoutCoupon = async (billId: string) => {
    console.log(billId);

  };
  const handlePrintNoReceipt = async (billId: string | null, useLoading?: boolean) => {
    if (!billId || !useLoading) return;
  };

  const handleCompletedTicket = async (billId: string | null, useLoading?: boolean) => {
    if (!billId) return;
    dispatch(cashierService.actions.resetPrinter());
    if (useLoading) setPageLoading(true);
    try {
      const response = await Promise.all([
        cashierApis.getCouponPrint(billId),
        cashierApis.getBillById(billId),
      ]);

      const couponPrint: IResponseData<any> = response[0];
      if (couponPrint.data.data) {
        dispatch(cashierService.actions.saveTicketPrinterCoupons(couponPrint.data.data.coupons));
      }

      const res: IResponseData<IBillInfoResData> = response[1];

      if (res.data.data) {
        dispatch(cashierService.actions.saveTicketPrinterDetail(res.data.data));
        delay(() => {
          const isCreditCard = res.data.data.payments?.find(o => o.paymentType === PAYMENT_TYPE.CREDIT_CARD);
          if (isCreditCard && !res.data.data.signature) return doPrintDoubleReceipt();
          doPrint();
        }, 100);
      }
    } catch (error) { } finally {
      if (useLoading) setPageLoading(false);
    }

  };

  const handlePrintMultiCards = async (billId: string) => {
    if (!billId) return;
  };

  return (
    <TicketWrapperContext value={{
      print: handlePrint,
      printWithoutCoupon: handlePrintWithoutCoupon,
      completedTicket: handleCompletedTicket,
      printMultiCards: handlePrintMultiCards,
      completedMultiCards: handleCompletedTicket,
      doPrintNoReceipt: handlePrintNoReceipt,
      doPrint,
      doPrintDoubleReceipt,
      doPrintOwnerReceipt,
    }}>
      <Outlet />
      <ReceiptLayout><TicketReceipt billRef={divRef} isPrinter /></ReceiptLayout>
      <ReceiptLayout><TicketReceipt billRef={divOwnerRef} isPrinter owner /></ReceiptLayout>
      {/* <div style={{ display: 'none' }}><ReceiptMultipleCardsPayment billRef={multiCardReceiptRef} isPrinter /></div> */}
      <TimeOutRefresh />
    </TicketWrapperContext>
  );
}

export default ReceiptsLayout;

const ReceiptLayout = styled.div`
  display: none;
`;

const TimeOutRefresh = () => {
  const handleReload = () => {
    const now = moment();
    const startTime = moment().set({ hour: 9, minute: 0, second: 0, });
    const endTime = moment().set({ hour: 21, minute: 0, second: 0, });

    if (now.isBetween(startTime, endTime)) return;

    if (storage.device_type.get() === SHOP_DEVICE_TYPE.SIGNATURE) {
      window.location.href = `${location.origin}/store/${storage.shop_id.get()}/check-in/sign-in`;
    } else {
      window.location.href = `${location.origin}/store/${storage.shop_id.get()}`;
    }
  };

  useEffect(() => {
    const time = setInterval(() => {
      handleReload();
    }, 7200000);
    return () => {
      clearInterval(time);
    };
  }, []);

  return null;
};